// @flow
import { fromJS, Map } from 'immutable';

import { GROUP_SIZE } from '~/core/constants/dashboard';
import { range } from 'lodash/fp';

export default (pages: Map<*, *>) => {
    if (!pages) {
        return Map();
    }

    // $FlowFixMe
    const nextAvailablePage = (pages.find(p => p.get('items').count() < GROUP_SIZE) || fromJS({ position: -1 })).get(
        'position'
    );
    // $FlowFixMe
    const usedPositions = pages
        .getIn([nextAvailablePage, 'items'], fromJS({}))
        .map(item => item.get('position'))
        .sort();
    const nextAvailablePos = range(0, GROUP_SIZE).filter(pos => !usedPositions.some(usedPos => usedPos === pos))[0];
    const nextPos = nextAvailablePos || nextAvailablePos === 0 ? nextAvailablePos : -1;

    return fromJS({ page: nextAvailablePage, position: nextPos });
};



// WEBPACK FOOTER //
// ./src/core/state/dashboard/nextAvailableProductSlot.js